import { api } from "./client";

export const NetworkScansAPI = {
  start: (payload = {}) => api.post("/network-scans", payload),
  latest: () => api.get("/network-scans/latest"),
  list: (params = {}) => api.get("/network-scans", { params }),
  get: (id) => api.get(`/network-scans/${id}`),
  rescan: (id) => api.post(`/network-scans/${id}/rescan`),
  updateStatus: (id, deviceId, payload = {}) => api.post(`/network-scans/${id}/devices/${deviceId}/status`, payload),
  bulkStatus: (id, payload = {}) => api.post(`/network-scans/${id}/devices/bulk-status`, payload),
  addToMonitor: (id, deviceId, payload = {}) => api.post(`/network-scans/${id}/devices/${deviceId}/add`, payload),
  addToAssets: (id, deviceId, payload = {}) => api.post(`/network-scans/${id}/devices/${deviceId}/add`, payload),
  delete: (id) => api.delete(`/network-scans/${id}`),
};
